import LocaleLink from "./LocaleLink";
export default LocaleLink;
